import { loadDemoActivities } from "@/data/demo/demoStore";
import type { ActivityTrackRow, TracksQueryOpts } from "@/types/map.types";
import { applyBasicFilters } from "@/utils/demo.utils";

export async function fetchMapActivitiesDemo(
  q: TracksQueryOpts,
): Promise<ActivityTrackRow[]> {
  const all = await loadDemoActivities();
  const rows = applyBasicFilters(all, q);
  return rows.map((a) => ({
    strava_activity_id: a.strava_activity_id,
    start_date: a.start_date,
    name: a.name,
    sport_type: a.sport_type,
    summary_polyline: a.summary_polyline,
  }));
}
